import React, { useState } from 'react';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';
import { Sublink, SubmenuWrapper, StyledCard, Header } from './styled';
import { SubmenuHeader } from '../styled';
import SublinkComponent from './Sublink/Sublink';
const Submenu = ({ id, contrast, isMobile, links, linkIcon }) => {
    const [showSubmenu, setShowSubmenu] = useState(false);
    const handleMouseState = () => {
        setShowSubmenu(!showSubmenu);
    };
    return (React.createElement(SubmenuHeader, { contrast: contrast, className: "universal-menu-link", onMouseEnter: handleMouseState, onMouseLeave: handleMouseState },
        React.createElement(Header, null,
            linkIcon && (React.createElement(Image, { src: linkIcon, alt: "verse logo", height: 23, width: 23 })),
            id),
        showSubmenu && (React.createElement(React.Fragment, null,
            React.createElement(SubmenuWrapper, null,
                !isMobile && (React.createElement(StyledCard, { contrast: contrast }, links.map(({ id: sublinkId, url, subheading, icon, alt, text }) => {
                    return (React.createElement("span", { key: sublinkId },
                        React.createElement(SublinkComponent, { sublinkId: sublinkId, url: url, subheading: subheading, icon: icon, alt: alt, text: text })));
                }))),
                isMobile &&
                    links.map(({ id: sublinkId, url }) => {
                        return (React.createElement(Sublink, { key: sublinkId, href: url, contrast: contrast, className: "universal-menu-link sublink", rel: "canonical" },
                            React.createElement("span", null, sublinkId)));
                    }))))));
};
export default Submenu;
//# sourceMappingURL=Submenu.js.map